// react
import React from "react";
// image
import ImageUploading from 'react-images-uploading';

const ProjectDetail = () => {
    const [images, setImages] = React.useState([]);
    const maxNumber = 10;
    const onChange = (imageList, addUpdateIndex) => {
        setImages(imageList);
    };
    return (
        <>
            <section>
                {/* admin page component */}
                <div className={'admin-page-content mb-3 pt-0'}>
                    <div id={'admin-page-form'}>
                        <p className={'fw-bold box-title'}>آپلود عکس</p>
                        <div className={'card card-body shadow border-0'}>
                            <ImageUploading
                                multiple
                                value={images}
                                onChange={onChange}
                                maxNumber={maxNumber}
                                dataURLKey="data_url"
                            >
                                {({
                                    imageList,
                                    onImageUpload,
                                    onImageRemoveAll,
                                    onImageRemove,
                                    onImageUpdate,
                                    isDragging,
                                    dragProps,
                                }) => (
                                    // write your building UI
                                    <div className="upload__image-wrapper">
                                        <div className="row">
                                            <div className="col-6">
                                                <button
                                                    className="upload-btn rounded rounded-3"
                                                    style={isDragging ? { color: 'red' } : undefined}
                                                    onClick={onImageUpload}
                                                    {...dragProps}
                                                >
                                                    برای آپلود  کلیک کنید
                                                </button>
                                            </div>
                                            <div className="col-6">
                                                <button onClick={onImageRemoveAll}
                                                    className="upload-btn mt-0 rounded rounded-3">
                                                    حذف آیتم
                                                </button>
                                            </div>
                                        </div>
                                        <div className="row mt-3 gy-4">
                                            {imageList.map((image, index) => (
                                                <div className="col-lg-2 col-md-3 col-6">
                                                    <div className="d-flex justify-content-center"
                                                        key={index}>
                                                        <div className="image-item">
                                                            <img src={image['data_url']} alt="upload"
                                                                className="img-fluid image-upload-done-b w-100 mt-3 mb-2" />
                                                            <div className="image-item__btn-wrapper d-flex">
                                                                <button
                                                                    className="upload-btn rounded rounded-4"
                                                                    onClick={() => onImageUpdate(index)}>
                                                                    آپدیت
                                                                </button>
                                                                <button className="upload-btn rounded rounded-4 ms-2" onClick={() => onImageRemove(index)}>حذف</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                )}
                            </ImageUploading>
                        </div>
                    </div>
                </div>
            </section >
        </>
    )
}

export default ProjectDetail;